import { HttpClient } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FlexModule } from "@ngbracket/ngx-layout";
import {
    L10N_CONFIG,
    L10N_LOCALE,
    L10nConfig,
    L10nLocale,
    L10nTranslatePipe,
    L10nTranslationService
} from 'angular-l10n';
import { APIConfigService } from "../../../api.config.service";
import { AngularMaterial2Module } from "../../../app.module.material";
import { AuthService } from "../../../shared/auth.service";
import { ErrorHelper } from "../../../shared/error.helper";
import { LoggerService } from "../../../shared/logger.service";
import { Kernantwort } from "../../../shared/response/kernantwort.model";
import { Datei } from "../../datei/datei.model";
import { DateiArt } from "../../datei/dateiart.model";
import { DateiArtDetails } from "../../datei/dateiartdetails.model";
import { RestServiceImpl } from "../rest.service.impl";
import { RestService } from "../rest.service.interface";
import { DateiExtenderUtils } from "./dateiExtenderUtils";

const PATH_FILE = 'app/protected/immerdrin/bild/images.select.component.ts';

@Component({
    selector: 'oase-images-select.dialog',
    templateUrl: './images.select.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, FlexModule]

})
export class ImagesSelectComponent {

    dateiArtDetails: DateiArtDetails = new DateiArtDetails(); // Wird benötigt da Angular2 nicht auf statische Methoden zugreifen kann!?
    seconddialogrunningajaxcall = false;
    aktuellDateien: Array<Datei> = Array<Datei>();
    fehlerMain: Kernantwort = null;
    public aktuell = null;
    OBJ_LNG_NAME = null;
    nurBild: boolean = true;
	setDatei: any;
	getDatei: any;

    constructor(
		public dialogRef: MatDialogRef<ImagesSelectComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public http: HttpClient,
        public _logger: LoggerService)
    {

        this.nurBild = data.nurBild;

        console.log('nurBild:'+this.nurBild);

        this.aktuell = data.aktuell;
        this.OBJ_LNG_NAME = data.OBJ_LNG_NAME;

		this.setDatei = data.setDatei;
		this.getDatei = data.getDatei;

        this.getDateien();

    }

  private getDateien() {
    this._logger.debug(PATH_FILE + ' - getDateien Begin');
    this.seconddialogrunningajaxcall = true;
    if (this.aktuellDateien.length > 0) return;
    this.http.get<Datei[]>(this.apiConfigService.REST_API_BASE() + "datei/"+(this.nurBild ? 'liste/BILD' : 'liste/ALLE'))
      .subscribe({
      next: (data) => {
        this.seconddialogrunningajaxcall = false;
        data.forEach((b: Datei) => {
            this.aktuellDateien.push(b);
        });
      for(const currentPicture of this.aktuellDateien) {
          if(currentPicture.art != DateiArt[DateiArt.BILD]) {
              DateiExtenderUtils.dateiExtender(this, currentPicture);
          }
      }
	  this._logger.debug(PATH_FILE + ' - aktuellDateien: ', this.aktuellDateien);
      this._logger.info(PATH_FILE + ' - getDateien End');
      },
      error: (err) => {
        this.seconddialogrunningajaxcall = false;
        ErrorHelper.handleError(err,"Fehler beim holen der Bilder",this._logger, this.translation)
      },
      complete: () => {
        this.seconddialogrunningajaxcall = false;
        this._logger.log(PATH_FILE + ' - Holen der Bilder abgeschlossen')
      }
    });
  } // getDateien


    setzeFehler(fehler: Kernantwort) {
        this.fehlerMain = fehler;
    }

	getBildVerkleinertUrl(datei: Datei, zusatz: string = ''): string {
		if(datei != null)
			return this.authService.getAuthUrl(datei.url + zusatz);
		return null;
	}

    isBild(datei: Datei) {
        return datei != null && datei.art == DateiArt[DateiArt.BILD];
    }

	isAlle(datei: Datei) {
		return datei != null && datei.art == DateiArt[DateiArt.ALLE];
	}
}
